module.exports = __webpack_public_path__ + "img/Suporte.e2351586.png";